
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcEventItem as ObcEventItemElement} from '@oicl/openbridge-webcomponents/dist/components/event-item/event-item.js';
 
 
 

 
 export const ObcEventItem = createComponent({
   react: React,
   tagName: 'obc-event-item',
   elementClass: ObcEventItemElement,
   events: {
     
     onEventClick: 'event-click' as EventName<CustomEvent<{title: string, startTime: string, endTime: string}>>,
   }
  });
 
 